import React, { Component } from "react"
import PropTypes from "prop-types"
import Slider from "react-slick"

import InsightCard from "./Card"

import "./Carousel.scss"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

class InsightCarousel extends Component {

  next = () => {
    this.slider.slickNext();
  }

  previous = () => {
    this.slider.slickPrev();
  }

  render = () => {

    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          }
        },
      ]
    }

    const { cards } = this.props

    return (
      <div className="insight-carousel">
        <button 
          className="button-control button-previous"
          aria-label="Previous"
          onClick={this.previous}
        />
        <Slider ref={c => this.slider = c } { ...settings }>
          {cards.map((card, index) => (
            <InsightCard card={card} key={index} />
          ))}
        </Slider>
        <button 
          className="button-control button-next"
          aria-label="Next"
          onClick={this.next}
        />
      </div>
    )
  }
}

InsightCarousel.defaultProps = {
  cards: [],
}

InsightCarousel.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.object),
}

export default InsightCarousel
